export default {
    install(app) {
        const menujs = {
            menu: [
                {
                    id: "MAIN1",
                    title: "나의 실손청구",
                    link: "/claim/web/insuClaim",
                    subMenu: [
                        {
                            id: "M101",
                            title: "원청구 선택",
                            link: "selectClaimNumber",
                        },
                        {
                            id: "M102",
                            title: "개인정보",
                            link: "information",
                        },
                        {
                            id: "M103",
                            title: "보험사 선택",
                            link: "insurance",
                        },
                        {
                            id: "M104",
                            title: "병원 선택",
                            link: "hospital",
                        },
                        {
                            id: "M105",
                            title: "진료내역 선택",
                            link: "treatMent",
                        },
                        {
                            id: "M106",
                            title: "청구정보",
                            link: "basicInfoClaim",
                        },
                        {
                            id: "M107",
                            title: "청구내용확인",
                            link: "detailClaim",
                        },
                        {
                            id: "M108",
                            title: "청구완료",
                            link: "resultClaim",
                        }
                    ]
                },
                {
                    id: "MAIN2",
                    title: "나의 자녀청구",
                    link: "/claim/web/childClaim",
                    subMenu: [
                        {
                            id: "M201",
                            title: "마이데이터 자녀조회",
                            link: "myDataFindChild",
                        },
                        {
                            id: "M202",
                            title: "자녀선택",
                            link: "childSelect",
                        }

                    ]
                },
                {
                    id: "MAIN3",
                    title: "나의부모/제3자 청구",
                    link: "/claim/web/deputyClaim",
                    subMenu: [
                        {
                            id: "M301",
                            title: "나의부모/제3자 청구 정보입력",
                            link: "deputyClaimInfo",
                        },
                        {
                            id: "M302",
                            title: "위임동의 요청",
                            link: "delegateApproval",
                        },
                        {
                            id: "M303",
                            title: "위임자 주민번호",
                            link: "delegateApprovalReg",
                        },
                        {
                            id: "M304",
                            title: "위임동의 완료",
                            link: "agreeDelegateResult",
                        },
                        {
                            id: "M305",
                            title: "위임동의 거절",
                            link: "delegateApprovalFali",
                        },

                        {
                            id: "M306",
                            title: "청구서 작성완료",
                            link: "deputyClaimResult",
                        },

                        {
                            id: "M307",
                            title: "보험사 약관 동의",
                            link: "agreeProxyInsurance",
                        },
                        {
                            id: "M308",
                            title: "청구내용확인",
                            link: "deputyClaimDetail",
                        },
                        {
                            id: "M309",
                            title: "청구서 작성완료(알림)",
                            link: "resultDeputyClaim",
                        },
                    ]
                },
                {
                    id: "MAIN4",
                    title: "고객지원",
                    link: "/claim/web/custSupp",
                    subMenu: [
                        {
                            id: "M401",
                            title: "문의하기",
                            link: "custSuppQNA",
                        },
                        {
                            id: "M402",
                            title: "공지사항",
                            link: "custSuppNotice",
                        },
                        {
                            id: "M403",
                            title: "자주하는 질문",
                            link: "custSuppFAQ",
                        },
                        {
                            id: "M404",
                            title: "자료실",
                            link: "custSuppLib",
                        },
                        {
                            id: "M405",
                            title: "AI챗봇상담",
                            link: "custSuppAI",
                        },
                        {
                            id: "M406",
                            title: "고객상담",
                            link: "custSuppService",
                        },
                    ]
                },
                {
                    id: "MAIN5",
                    title: "마이페이지",
                    link: "/claim/web/myPage",
                    subMenu: [
                        {
                            id: "M501",
                            title: "내 정보관리",
                            link: "myInformation",
                        },
                        {
                            id: "M502",
                            title: "청구이력",
                            link: "myClaim",
                        },
                        {
                            id: "M503",
                            title: "나의 보험관리",
                            link: "myInsurance",
                        },
                        {
                            id: "M504",
                            title: "나의 병원관리",
                            link: "myHospital",
                        },
                        {
                            id: "M506",
                            title: "나의 자녀관리",
                            link: "myChildren",
                        },
                        {
                            id: "M507",
                            title: "나의 위임관리",
                            link: "myDelegate",
                        },
                        {
                            id: "M508",
                            title: "약관동의 관리",
                            link: "agreePolicy",
                        },
                        {
                            id: "M509",
                            title: "환경설정",
                            link: "mySetting",
                        },
                    ]
                },
                {
                    id: "MAIN6",
                    title: "시스템소개",
                    link: "/claim/web/systemIntro",
                },
            ]
        }

        app.provide('menujs', menujs);
    },
};
